import { render, staticRenderFns } from "./Configuracoes.vue?vue&type=template&id=272f8a18&scoped=true"
import script from "./Configuracoes.vue?vue&type=script&lang=js"
export * from "./Configuracoes.vue?vue&type=script&lang=js"
import style0 from "./Configuracoes.vue?vue&type=style&index=0&id=272f8a18&prod&scoped=true&lang=css"
import style1 from "./Configuracoes.vue?vue&type=style&index=1&id=272f8a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f8a18",
  null
  
)

export default component.exports